<template>
  <template v-if="step === 'amount'">
    <DrawerHeader @close="emit('back')">
      Card Payment Amount
    </DrawerHeader>
    <div class="flex flex-1 flex-col px-6">
      <div class="mb-4 flex flex-1 flex-col px-8">
        <div
          class="flex flex-1 flex-col items-center justify-center"
        >
          <CustomAmountDisplay :value="amountInput" />
        </div>
        <div class="mb-1 flex items-center justify-between">
          <h3 class="text-xs text-background-fg/50">
            Remaining Due
          </h3>
          <p
            class="text-lg font-bold leading-tight text-background-fg/87"
          >
            {{
              formatToMerchantCurrencyString(remainingDue)
            }}
          </p>
        </div>
      </div>

      <BaseNumpad v-model="amountInput" />
    </div>
    <div class="flex items-center justify-center p-4">
      <ActionButtonPrimary
        class="w-full"
        :disabled="
          !isGratuityEnabled && amountInput > remainingDue
        "
        @click="onSubmitAmount"
      >
        Pay
        {{ formatToMerchantCurrencyString(amountInput) }}
      </ActionButtonPrimary>
    </div>
  </template>
  <template v-else>
    <PaymentCardGratuity
      :amount-gross="amountInput"
      @submit="onSubmitGratuity"
      @cancel="emit('back')"
    />
  </template>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()

const props = defineProps<{
  amount: number | null
  remainingDue: number
}>()
const emit = defineEmits<{
  (
    event: "submit",
    amountGross: number,
    amountGratuity: number
  ): void
  (event: "back"): void
}>()

const { isGratuityEnabled } = useTenant()
const step = ref<"amount" | "gratuity">("amount")

onMounted(() => {
  if (props.amount !== null) {
    amountInput.value = props.amount
    onSubmitAmount()
  }
})

const onSubmitAmount = () => {
  if (isGratuityEnabled.value && props.amount !== null) {
    step.value = "gratuity"
  } else {
    emit("submit", amountInput.value, 0)
  }
}

const onSubmitGratuity = (gratuity: number) => {
  emit("submit", amountInput.value, gratuity)
}

const amountInput = ref(0)
</script>
